export default "__VITE_ASSET__7cc487a0__"